const userReducer = (state = [], { type, res }) => {
  switch (type) {
    case 'set':
      return res
    default:
      return state
  }
}
export default userReducer
